import {select, Tail} from 'redux-saga/effects';
import {IReduxState} from '../store';

export function* typedSelect<T>(
  selector: (state: IReduxState, ...args: any[]) => T,
  ...args: Tail<Parameters<typeof selector>>
) {
  const res: T = yield select(selector, args);
  return res;
}
